import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import {CustomToolbar, Grid, schoolYears} from '../../components'
import AdmissionSttConfigFields from './AdmissionSttConfigFields'

const defaultValues = {
    schoolYearId: schoolYears != null && schoolYears.length > 0 ? schoolYears[0].id : null
}

export const AdmissionSttConfigCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" defaultValue={defaultValues} >
      <Grid container spacing={8}>
        <AdmissionSttConfigFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default AdmissionSttConfigCreate
